function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 24 24",
    width: 25,
    height: 25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "file-image-o",
    d: "M16,3.38c-0.23-0.22-0.5-0.39-0.79-0.5c-0.29-0.13-0.6-0.2-0.92-0.21H5c-0.55,0-1,0.45-1,1v16.66  c0,0.55,0.45,1,1,1h14c0.55,0,1-0.45,1-1v-12c-0.01-0.32-0.08-0.63-0.21-0.92c-0.11-0.29-0.28-0.56-0.5-0.79L16,3.38z M15.05,4.32  l3.26,3.26c0.11,0.13,0.19,0.27,0.23,0.43h-3.87V4.09c0.15,0.05,0.3,0.12,0.42,0.23H15.05z M18.66,20H5.34V4h8v4.34  c0,0.55,0.45,1,1,1h4.33V20l0,0H18.66z M14,12l-4,4l-1.33-1.33l-2,2v2h10.66v-3.34L14,12z M10.09,12.75  c0.78-0.78,0.79-2.04,0.01-2.83C9.72,9.54,9.21,9.33,8.67,9.33c-1.1,0-2,0.89-2,2c0,0.53,0.21,1.04,0.58,1.41  c0.78,0.78,2.04,0.79,2.83,0.01c0,0,0,0,0,0H10.09z",
    style: {
      fill: "rgb(84, 88, 90)"
    },
    vectorEffect: "non-scaling-stroke"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.2c19d1e3.svg";
export { ForwardRef as ReactComponent };